import { AnalyticsEvent, AnalyticsManager } from '@oy/analytics';
import { Button, ButtonWithIcon, IconButton } from '@oy/uidesktop';
import { Link } from 'react-router-dom';
import { Tooltip } from 'react-tooltip';
import { B2xPermissionDetail, B2xPermissionProducts } from 'src/constants';
import {
  useEnv,
  usePermission,
  useProductActiveV2,
  useTranslate,
  useUserRole,
} from 'src/hooks';
import { ShortcutSideModal } from 'src/pages/Disbursement/components/ShortcutSideModal/ShortcutSideModal';
import { ShortcutDisbursementProducts } from 'src/pages/Disbursement/components/ShortcutSideModal/constant';
import { AutoReportProvider } from '../AutoReportFormSideModal/AutoReportProvider';
import styles from './RouterActionButton.module.css';
import { useActionButtonShortcutImpl } from './useActionButtonShortcutImpl';

const InternationalRemitListActionButton = () => {
  const { getTranslation } = useTranslate();
  const { isProdEnv } = useEnv();
  const { checkActive } = useProductActiveV2();
  const { hasPermission } = usePermission();
  const { isSuperAdmin, isAdmin } = useUserRole();

  const { state, action } = useActionButtonShortcutImpl();
  const { showShortcutSideModal, showAutoReportModal } = state;

  const {
    closeShortcutSideModal,
    openShortcutSideModal,
    setShowAutoReportModal,
    handleAutoReportModal,
  } = action;

  const userHasMakerPermissionBulk = hasPermission(
    B2xPermissionProducts.BULK_DISBURSEMENT,
    B2xPermissionDetail.MAKER,
  );

  const disabledButton = () => {
    return isProdEnv && !checkActive('INTERNATIONAL_TRANSFER');
  };

  return (
    <div id="coachList5">
      {userHasMakerPermissionBulk && (
        <>
          <Link
            id="btnCreateInterationalTransfer"
            onClick={() => {
              AnalyticsManager.instance().track(
                AnalyticsEvent.inter_remit_create,
              );
            }}
            to={'/disbursement/create-international-remittance-transaction'}
          >
            <ButtonWithIcon
              data-tooltip-id="create-international-transfer-disabled-tooltip"
              data-tooltip-content={
                disabledButton()
                  ? getTranslation('claimFund_disabledCreateButtonTooltip')
                  : undefined
              }
              data-tooltip-place="bottom"
              iconName="add"
              disabled={disabledButton()}
              size={Button.Size.Small}
            >
              {getTranslation('common_createNewTransaction')}
            </ButtonWithIcon>
          </Link>
          <Tooltip
            place="bottom"
            style={{
              zIndex: 9999,
              fontSize: '12px',
              maxWidth: '250px',
            }}
            id="create-international-transfer-disabled-tooltip"
          />
        </>
      )}

      <IconButton
        data-tooltip-id="configs-international-transfer-disabled-tooltip"
        data-tooltip-content={
          !isAdmin && !isSuperAdmin
            ? getTranslation(
                'helpConfiguration_title_internationalTransfer_disabledInfo',
              )
            : undefined
        }
        data-tooltip-place="bottom"
        isDedupe
        iconName="configs"
        color={IconButton.Color.Secondary}
        size={IconButton.Size.Medium}
        buttonType={IconButton.Type.SquareOutlined}
        className={styles.helpButton}
        onClick={openShortcutSideModal}
        disabled={!isAdmin && !isSuperAdmin}
      />
      <Tooltip
        place="bottom"
        style={{
          zIndex: 9999,
          fontSize: '12px',
          maxWidth: '250px',
        }}
        id="configs-international-transfer-disabled-tooltip"
      />

      <AutoReportProvider
        productName={ShortcutDisbursementProducts.INTERNATIONAL_TRANSFER}
        showSideModalParent={showAutoReportModal}
        isShowToggleActivated={true}
        onClose={() => {
          setShowAutoReportModal(false);
          openShortcutSideModal();
        }}
      >
        {showShortcutSideModal && (
          <ShortcutSideModal
            productName={ShortcutDisbursementProducts.INTERNATIONAL_TRANSFER}
            show={showShortcutSideModal}
            showVendorMaintenance={false}
            onClose={closeShortcutSideModal}
            handleToggleSideModal={() => {}}
            handleAutoReportModal={handleAutoReportModal}
            handleFaqModal={() => {}}
          />
        )}
      </AutoReportProvider>
    </div>
  );
};

export default InternationalRemitListActionButton;
